export const states = {
  loadManifest: { availableStates: ['loading'], nextState: 'loading' },
  loading: { availableStates: ['reset'], nextState: 'reset' },
  reset: { availableStates: ['initialization'], nextState: 'initialization' },
  initialization: { availableStates: ['initLevel'], nextState: 'initLevel' },
  initLevel: { availableStates: ['showing'], nextState: 'showing' },
  showing: { availableStates: ['tutorial'], nextState: 'tutorial' },
  tutorial: { availableStates: ['demonstration'], nextState: 'demonstration' },
  demonstration: { availableStates: ['playing'], nextState: 'playing' },
  playing: { availableStates: ['win', 'lose', 'paused', 'reset'] },
  paused: { availableStates: ['playing'], nextState: 'playing' },
  lose: { availableStates: ['reset'], nextState: 'reset' },
  win: { availableStates: [], nextState: '' },
};

export const ignoreStates = ['playing', 'lose', 'win', 'paused', 'tutorial'];

export const levels = [
  {
    columns: 3,
    rows: 2,
    products: ['0', '1', '2'],
    empties: [],
    strict: [],
  },
  {
    columns: 3,
    rows: 4,
    products: ['0', '1', '2', '3'],
    empties: [
      [0, 0],
      [0, 2],
      [3, 0],
      [3, 2],
    ],
    strict: [0, 3],
  },
  {
    columns: 3,
    rows: 4,
    products: ['0', '1', '2', '3', '4'],
    empties: [
      [0, 1],
      [3, 1],
    ],
    strict: [],
  },
  {
    columns: 3,
    rows: 5,
    products: ['0', '1', '2', '3', '4', '5'],
    empties: [
      [0, 1],
      [2, 1],
      [4, 1],
    ],
    strict: [2],
  },
];

export const START_LIFES = 5;

export const START_SCORE = 0;
